import * as S from './styles';

const FILTERS = [
  { id: 'all', label: 'Todos' },
  { id: 'recent', label: 'Recentes' },
  { id: 'popular', label: 'Populares' },
  { id: 'moderators', label: 'Moderadores' },
  { id: 'media', label: 'Com mídia' },
];

type FeedFiltersProps = {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
};

const FeedFilters = ({ activeFilter, onFilterChange }: FeedFiltersProps) => (
  <S.Container>
    {FILTERS.map((filter) => (
      <S.FilterChip
        key={filter.id}
        type="button"
        $active={activeFilter === filter.id}
        onClick={() => onFilterChange(filter.id)}
      >
        {filter.label}
      </S.FilterChip>
    ))}
  </S.Container>
);

export default FeedFilters;
